import { Avatar, Container, Link, List, ListItem, ListItemAvatar, ListItemText, Paper, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { renderIfElse } from "../../../../utils";
import { useTranslation } from "react-i18next";
import * as propTypes from 'prop-types';
import CryptoIcon from "../../../../assets/logo/crypto-white.svg";
import WireIcon from "../../../../assets/logo/wire-white.svg";
import WireIconBlue from "../../../../assets/logo/wire-blue.svg";
import CryptoIconBlue from "../../../../assets/logo/crypto-themed.svg";
import { useDispatch, useSelector } from "react-redux";
import { getCurrenciesData } from "../../../../store/actions";
import AppScreenLoader from "../../../../components/AppScreenLoader";
export default function Step2({ payment, paymentOptions, styles,
    handlePaymentMethod }) {
    const dispatch = useDispatch();
    const enableFiat = useSelector(({ dashboard }) => !!dashboard?.enableFiat);
    const currencies = useSelector(({ currencies }) => currencies.currencies);
    const { t } = useTranslation();
    useEffect(() => {
        dispatch(getCurrenciesData());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if(!currencies) {
        return <AppScreenLoader />;
    }
    return (<Paper
        sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
            paddingTop: 1,
        }}
    >

        {(!currencies?.length && !enableFiat) && <Container maxWidth="md">
            <Typography variant="body2" fontSize={16} marginTop={5} textAlign={'left'}>
                {t('NoPaymentMethod')} <Link href="mailto:support@rocketfuel.inc" target="_blank" color={"#0088F5"}>support@rocketfuel.inc</Link>
            </Typography>
        </Container>}
        <List>
            {!!currencies?.length && <ListItem
                style={payment === paymentOptions.crypto ? styles.selected : {}}
                onClick={(ev) => handlePaymentMethod(ev, paymentOptions.crypto)}
            >
                <ListItemAvatar>
                    <Avatar>
                        {renderIfElse(
                            payment === "crypto",
                            <CryptoIconBlue />,
                            <CryptoIcon />
                        )}
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={t('crypto.transfer')} secondary={t('crypto.transfer.duration')} />
            </ListItem>}
            {!!enableFiat && <ListItem
                style={payment === paymentOptions.nonCrypto ? styles.selected : {}}
                onClick={(ev) => handlePaymentMethod(ev, paymentOptions.nonCrypto)}>
                <ListItemAvatar>
                    <Avatar>
                        {renderIfElse(
                            payment === "non-crypto",
                            <WireIconBlue />,
                            <WireIcon />
                        )}

                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={t('bank.transfer')}
                    secondary={t('bank.transfer.duration')}
                />
            </ListItem>}
            {/* {config.ENABLE_MASSPAY && <ListItem
                style={payment === paymentOptions.actum ? styles.selected : {}}
                onClick={(ev) => handlePaymentMethod(ev, paymentOptions.actum)}>
                <ListItemAvatar>
                    <Avatar>
                        {renderIfElse(
                            payment === paymentOptions.actum,
                            <WireIconBlue />,
                            <WireIcon />
                        )}

                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={t('bank.transfer')}
                    secondary={t('mayTakeBusinessDays')}
                />
            </ListItem>} */}

        </List>
    </Paper>)
}

Step2.propTypes = {
    payment: propTypes.any,
    paymentOptions: propTypes.any,
    styles: propTypes.any,
    handlePaymentMethod: propTypes.any
}